module.exports = __webpack_public_path__ + "static/media/doorclosed.33215b57.png";